export default {"src":"/_next/static/media/international-driver-permit.0f11c3a6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};